import { render } from "./ReferenceStructureBlock.vue?vue&type=template&id=7f91d24a&scoped=true"
import script from "./ReferenceStructureBlock.vue?vue&type=script&lang=js"
export * from "./ReferenceStructureBlock.vue?vue&type=script&lang=js"

import "./ReferenceStructureBlock.vue?vue&type=style&index=0&id=7f91d24a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f91d24a"]])

export default __exports__